import { render } from "./TalleresFestivalPage.vue?vue&type=template&id=360778ff&scoped=true"
import script from "./TalleresFestivalPage.vue?vue&type=script&lang=js"
export * from "./TalleresFestivalPage.vue?vue&type=script&lang=js"

import "./TalleresFestivalPage.vue?vue&type=style&index=0&id=360778ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360778ff"]])

export default __exports__